/**
 * Constants for onboarding step sections
 */
export const ONBOARDING_SECTIONS = {
  QUICK_START: 'quick-start',
  SETUP: 'setup',
  OPTIMIZE: 'optimize',
  TRAINING: 'training',
  LEGACY: 'legacy',
} as const

export type OnboardingSectionType =
  typeof ONBOARDING_SECTIONS[keyof typeof ONBOARDING_SECTIONS]
